import { MouseEventHandler, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNavigateToCreateRoutePath = (
  createRoutePath: string
): MouseEventHandler<HTMLButtonElement> => {
  const navigate = useNavigate();
  return useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    navigate(createRoutePath);
  }, [createRoutePath]);
};
